<template>
  <div class="header" janoo_layout="header" >
    <b-container fluid>
      <div class="header-body">
        <slot></slot>
      </div>
    </b-container>
  </div>
</template>
<script>
export default {
  name: 'base-header',
  props: {
    type: {
      type: String,
      default: 'black',
      description: 'Header background type',
    },
  },
}
</script>
<style></style>
